// @flow

import React, { type Node } from 'react';

import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { getSafePixQRCode, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';

import { HighlightBox, Separator } from '@tectonics/look-and-feel/uber-v2/atoms';
import styled from 'styled-components';
import { CopyToClipboardButton } from '@tectonics/look-and-feel/uber-v2/molecules/copy-to-clipboard';

import { PixLogoFull } from '@tectonics/look-and-feel/uber-v2/page-payment-pending/payment-method/pix/pix-logo';
import { theme } from '@tectonics/look-and-feel/uber-v2/theme';

export function PixCode(): Node {
  const allFeatures = useAllFeatures();
  const incomingPayment = usePendingIncomingPayment();
  const pixCode = getSafePixQRCode(incomingPayment);

  return (
    <section>
      <Separator pattern="dotted" direction="vertical"/>

      <IfFeature allFeatures={allFeatures} wanted="display_pix_logo_full">
        <PixLogoFull />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_pix_message">
        <PixMessage>
          Copie o código Pix abaixo e cole em seu app de pagamento para finalizar a compra.
        </PixMessage>
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_pix_qr_code_value">
        <PixQRCodeValue tabIndex="0">
          {pixCode}
        </PixQRCodeValue>
      </IfFeature>

      <Separator direction="horizontal" size={4} />

      <IfFeature allFeatures={allFeatures} wanted="display_pix_copy_code">
        <CopyToClipboardButton
          copyMessage="Copiar código pix"
          copiedMessage="Copiado!"
          value={pixCode}
        />
      </IfFeature>

      <Separator direction="horizontal" size={4} />

      <Separator pattern="dotted" direction="vertical"/>
    </section>
  );
}

const PixMessage = styled.p`
  text-align: center;
  font-size: 16px;
  margin-bottom: 21px;
  font-family: ${theme.fontFamily.sansSerif};
  font-style: normal;
  color: hsla(0,0%,40%,1);
`;

const PixQRCodeValue = styled(HighlightBox)`
  border-color: transparent;
  color: hsla(0,0%,40%,1);
  border-radius: 5px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  padding: 6px;
  white-space: nowrap;
  overflow-y: hidden;
  font-family: ${theme.fontFamily.sansSerif};
`;
